import { PageLink, PageTitle } from '_metronic/layout/core';
import { FC } from 'react';
import { DetalleNominaView } from './components/detalleNominaview';


const DetallesNominaPage: FC = () => {
  const breadCrumbs: Array<PageLink> = [
    {
      title: 'Nómina',
      path: '/configuracion/nomina',
      isSeparator: false,
      isActive: true,
    },
    {
      title: 'nómina',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];

  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Detalles Nóminas</PageTitle>
      <DetalleNominaView/>
    </>
  );
};

export {DetallesNominaPage}